module.exports = __webpack_public_path__ + "web/img/chapter-60.20ad38a3.png";